import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductsHero from '../components/ProductsHero';
import ProductsList from '../components/ProductsList';
import './ProductsPage.css';
import useSEO from '../hooks/useSEO';

const ProductsPage = () => {
    useSEO({
        title: "Physiotherapy & Rehabilitation Equipment Products | Prime Rehab Industries",
        description: "Explore Prime Rehab Industries' full range of physiotherapy, chiropractic, traction and rehabilitation equipment manufactured in Chennai for clinics and hospitals across India.",
        canonical: "https://www.primerehabindustries.in/products"
    });
    // Scroll to top on mount so navbar click always starts at the hero section
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="products-page">
            <Navbar />

            <main className="products-page-content">
                <ProductsHero />
                <ProductsList />
            </main>

            <Footer />
        </div>
    );
};

export default ProductsPage;
